import { REQUEST_SUCCESS } from '../../customer/redux/contact/contact.actions';
import { SUBMIT_SUCCESS } from '../../customer/redux/custom-swag/custom-swag.actions';
import { REQUEST_AUTOMATION_CONTACT_SUCCESS, REQUEST_ENTERPRISE_SUCCESS, REQUEST_GIVEAWAY_CONTACT_SUCCESS, REQUEST_IN_A_BOX_CONTACT_SUCCESS, REQUEST_SHOPIFY_CONTACT_SUCCESS, REQUEST_ZAPIER_CONTACT_SUCCESS } from '../../customer/redux/landings/landings.actions';
import { AUTOMATION_FORM, CONTACT_FORM, CUSTOM_SWAG_FORM, ENTERPRISE_FORM, GIVEAWAY_FORM, IN_A_BOX_FORM, REQUEST_DEMO_FORM, SHOPIFY_FORM, ZAPIER_FORM } from '../../customer/redux/redux.constants';
import { REQUEST_DEMO_SUCCESS } from '../../customer/redux/send-email/send-email.action';
export const mapActionTypeToFormAndLandingName = {
  [REQUEST_DEMO_SUCCESS]: {
    formName: REQUEST_DEMO_FORM,
    landingPageName: 'What we offer'
  },
  [REQUEST_ENTERPRISE_SUCCESS]: {
    formName: ENTERPRISE_FORM,
    landingPageName: 'Swag distribution'
  },
  [REQUEST_IN_A_BOX_CONTACT_SUCCESS]: {
    formName: IN_A_BOX_FORM,
    landingPageName: 'Swag in a box'
  },
  [REQUEST_GIVEAWAY_CONTACT_SUCCESS]: {
    formName: GIVEAWAY_FORM,
    landingPageName: 'Corporate gifting'
  },
  [REQUEST_SHOPIFY_CONTACT_SUCCESS]: {
    formName: SHOPIFY_FORM,
    landingPageName: 'Company stores'
  },
  [REQUEST_AUTOMATION_CONTACT_SUCCESS]: {
    formName: AUTOMATION_FORM,
    landingPageName: 'Swag automation'
  },
  [REQUEST_ZAPIER_CONTACT_SUCCESS]: {
    formName: ZAPIER_FORM,
    landingPageName: 'Zapier Integration'
  },
  [SUBMIT_SUCCESS]: {
    formName: CUSTOM_SWAG_FORM,
    landingPageName: 'Fully custom swag'
  },
  [REQUEST_SUCCESS]: {
    formName: CONTACT_FORM,
    landingPageName: "Let's talk"
  }
};
export let GOOGLE_TAG_MANAGER_EVENT = /*#__PURE__*/function (GOOGLE_TAG_MANAGER_EVENT) {
  GOOGLE_TAG_MANAGER_EVENT["FORM_SUBMIT"] = "swag_form_submit";
  GOOGLE_TAG_MANAGER_EVENT["ADD_TO_CART"] = "add_to_cart";
  GOOGLE_TAG_MANAGER_EVENT["VIEW_CART"] = "view_cart";
  GOOGLE_TAG_MANAGER_EVENT["REMOVE_FROM_CART"] = "remove_from_cart";
  GOOGLE_TAG_MANAGER_EVENT["BEGIN_CHECKOUT"] = "begin_checkout";
  GOOGLE_TAG_MANAGER_EVENT["ADD_SHIPPING_INFO"] = "add_shipping_info";
  GOOGLE_TAG_MANAGER_EVENT["CHECKOUT_PAYMENT_INFO"] = "checkout_payment_info";
  GOOGLE_TAG_MANAGER_EVENT["PURCHASE"] = "purchase";
  GOOGLE_TAG_MANAGER_EVENT["VIEW_ITEM"] = "view_item";
  GOOGLE_TAG_MANAGER_EVENT["SEARCH_RESULTS_QUICK_SEARCH"] = "search_results_quick_search";
  GOOGLE_TAG_MANAGER_EVENT["SEARCH_RESULTS_SEARCH_PAGE"] = "search_results_search_page";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_PORTAL_OPENED"] = "inv_inventory_portal_opened";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_ORDER_MORE_BUTTON_CLICKED"] = "inv_order_more_button_clicked";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_SOA_STARTED"] = "inv_soa_started";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_SOA_COMPLETED"] = "inv_soa_completed";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_SMA_STARTED"] = "inv_sma_started";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_SMA_COMPLETED"] = "inv_sma_completed";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_GIVEAWAY_STARTED"] = "inv_giveaway_started";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_GIVEAWAY_COMPLETED"] = "inv_giveaway_completed";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_GIVEAWAY_LINK_SUBMITTED"] = "inv_giveaway_link_submitted";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_GIVEAWAY_FEE_PAID"] = "inv_giveaway_fee_paid";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_GIVEAWAY_EDIT_STARTED"] = "inv_giveaway_edit_started";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_GIVEAWAY_AUTOPAY_TOGGLED"] = "inv_giveaway_autopay_toggled";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_PRODUCT_SELECTED"] = "inv_product_selected";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_SETTINGS_OPENED"] = "inv_settings_opened";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_CLOSET_PERMISSIONS_UPDATED"] = "inv_closet_permissions_updated";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_PAYMENT_METHODS_OPENED"] = "inv_payment_methods_opened";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_PAYMENT_METHODS_SAVED"] = "inv_payment_methods_saved";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_CLOSET_SWITCHED"] = "inv_closet_switched";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_ACTIVITY_PAGES_CLICKED"] = "inv_activity_pages_clicked";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_VIEW_STORAGE_FEES_CLICKED"] = "inv_view_storage_fees_clicked";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_CREDITS_CLICKED"] = "inv_inventory_credits_clicked";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_FAQ_PAGE_OPENED"] = "inv_faq_page_opened";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_MANAGE_IMAGES_CLICKED"] = "inv_manage_images_clicked";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_COLOR_SWATCHES_CLICKED"] = "inv_color_swatches_clicked";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_ORDER_APPROVED"] = "inv_order_approved";
  GOOGLE_TAG_MANAGER_EVENT["INVENTORY_ORDER_REJECTED"] = "inv_order_rejected";
  return GOOGLE_TAG_MANAGER_EVENT;
}({});
export let ACTIVITY_SUB_TABS = /*#__PURE__*/function (ACTIVITY_SUB_TABS) {
  ACTIVITY_SUB_TABS["SOA"] = "soa";
  ACTIVITY_SUB_TABS["SMA"] = "sma";
  ACTIVITY_SUB_TABS["GIVEAWAY"] = "giveaway";
  ACTIVITY_SUB_TABS["TRANSFER_PRODUCTS"] = "transfer_products";
  ACTIVITY_SUB_TABS["PENDING_APPROVAL"] = "pending_approval";
  return ACTIVITY_SUB_TABS;
}({});
export let GOOGLE_TAG_MANAGER_DEFAULT_VALUES = /*#__PURE__*/function (GOOGLE_TAG_MANAGER_DEFAULT_VALUES) {
  GOOGLE_TAG_MANAGER_DEFAULT_VALUES["CURRENCY"] = "USD";
  return GOOGLE_TAG_MANAGER_DEFAULT_VALUES;
}({});
export let DISTRIBUTION_BUTTON_LOCATIONS = /*#__PURE__*/function (DISTRIBUTION_BUTTON_LOCATIONS) {
  DISTRIBUTION_BUTTON_LOCATIONS["BOTTOM_MENU"] = "bottom_menu";
  DISTRIBUTION_BUTTON_LOCATIONS["ITEM_MENU"] = "item_menu";
  DISTRIBUTION_BUTTON_LOCATIONS["GIVEAWAY_POPUP"] = "popup_step_two";
  return DISTRIBUTION_BUTTON_LOCATIONS;
}({});
export let CREDITS_STATE = /*#__PURE__*/function (CREDITS_STATE) {
  CREDITS_STATE["CREDITS_NOT_AVAILABLE"] = "buy_credits";
  CREDITS_STATE["CREDITS_AVAILABLE"] = "credits_available";
  return CREDITS_STATE;
}({});
export const PERMISSION_LEVELS = {
  PUSH: 'push',
  PULL: 'distribute',
  PUSH_AND_PULL: 'add_and_distribute',
  ADMIN: 'admin'
};